import './styles/main.scss'
import { startGame } from './scripts/game'
startGame()
